import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import didInsert from 'webapp/modifiers/did-insert';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	onClose: () => void;
}

export default class AppNotificationsLegacyMetricsComponent extends Component<Args> {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('user-settings') declare userSettingsService: Service.UserSettings;

	@action
	markAsSeen(): void {
		void this.userSettingsService.save(UserSettingsKey.LEGACY_METRICS_BANNER_SEEN, true);
	}

	@action
	navigateToMigration(): void {
		this.navigationService.transitionToRoute('legacy-metric-migration');
	}

	<template>
		<div
			class="notification-container legacy-metrics-notification"
			{{didInsert this.markAsSeen}}
		>
			<div class="container">
				<a role="button" class="close" {{on "click" @onClose}}>
					<CommonUiIconComponent @name="Close" @size="sm" />
				</a>
				<p>
					You have legacy metrics that can be migrated to the new dataset-based metrics.
					<a role="button" {{on "click" this.navigateToMigration}}>
						Migrate now
					</a>
				</p>
			</div>
		</div>
	</template>
}
